var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.758,
    height: 47.416,
    viewBox: "0 0 73.758 47.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-eye-2943220",
    transform: "translate(-2 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10969",
    "data-name": "Caminho 10969",
    d: "M38.879,7C23.074,7,9.9,17.537,2,30.708,9.9,43.879,23.074,54.416,38.879,54.416S67.855,43.879,75.758,30.708C67.855,17.537,54.684,7,38.879,7Zm0,40.83A17.122,17.122,0,1,1,56,30.708,17.122,17.122,0,0,1,38.879,47.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10970",
    "data-name": "Caminho 10970",
    d: "M22.537,12a10.428,10.428,0,0,0-4.478,1.033,3.942,3.942,0,1,1-5.026,5.026A10.428,10.428,0,0,0,12,22.537,10.537,10.537,0,1,0,22.537,12Z",
    transform: "translate(16.342 8.171)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.89f02b0a5945be042f4e3e332b3937db.svg";
export { ForwardRef as ReactComponent };